import { useEffect } from "react";

export const SITE = process.env.REACT_APP_SITE_URL || "https://alphaomegavitality.com";
export const DEFAULT_OG_IMAGE =
  "https://cdn.shopify.com/s/files/1/0693/0287/8457/files/alphaorangedesktop.webp";
export const TWITTER_HANDLE = "@Alphapulsefit";

const upsertMeta = (key, content, attr = "name") => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const injectJsonLd = (id, obj) => {
  document.getElementById(id)?.remove();
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.text = JSON.stringify(obj);
  document.head.appendChild(s);
};

// Keeps document title + core meta tags in sync per client route.
export function useSeo({ title, description, canonical, keywords, image, type = "website" }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("description", description);
    if (keywords) upsertMeta("keywords", keywords);
    upsertMeta("robots", "index, follow, max-image-preview:large, max-snippet:-1");
    upsertMeta("author", "Alpha Omega Vitality");
    const url = canonical || `${SITE}/`;
    const img = image || DEFAULT_OG_IMAGE;
    upsertCanonical(url);
    // Open Graph
    upsertMeta("og:site_name", "Alpha Omega Vitality", "property");
    upsertMeta("og:locale", "en_US", "property");
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:url", url, "property");
    upsertMeta("og:type", type, "property");
    upsertMeta("og:image", img, "property");
    // Twitter
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:site", TWITTER_HANDLE);
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);
    upsertMeta("twitter:image", img);
  }, [title, description, canonical, keywords, image, type]);
}
